<article
  class="license-batch-card"
  role="button"
  tabindex="0"
  aria-label="View license batch details"
  (click)="onView()"
  (keydown.enter)="onView()"
  (keydown.space)="onView(); $event.preventDefault()"
>
  <div class="license-batch-card-head">
    <div class="license-batch-title-block">
      <h3>{{ batchTitle }}</h3>
      <span class="batch-id" *ngIf="batch?.id">ID: {{ batch?.id }}</span>
    </div>

    <div class="license-batch-actions">
      <button
        *ngIf="showEditAction"
        class="icon-action-btn edit-btn"
        type="button"
        aria-label="Edit license batch"
        matTooltip="Edit batch"
        (click)="onEdit($event)"
      >
        <mat-icon class="outlined-icon">edit</mat-icon>
      </button>

      <button
        *ngIf="showManageDevicesAction && !isUserTarget"
        class="icon-action-btn link-btn"
        type="button"
        aria-label="Manage license batch devices"
        matTooltip="Manage devices"
        (click)="onManageDevices($event)"
      >
        <mat-icon class="outlined-icon">link</mat-icon>
      </button>

      <button
        *ngIf="showManageDevicesAction && isUserTarget"
        class="icon-action-btn link-btn"
        type="button"
        aria-label="Manage license batch users"
        matTooltip="Manage users"
        (click)="onManageUsers($event)"
      >
        <mat-icon class="outlined-icon">group</mat-icon>
      </button>

      <button
        *ngIf="showDeleteAction"
        class="icon-action-btn delete-btn"
        type="button"
        aria-label="Delete license batch"
        matTooltip="Delete batch"
        (click)="onDelete($event)"
      >
        <mat-icon class="outlined-icon">delete</mat-icon>
      </button>
    </div>
  </div>

  <div class="batch-metadata">
    <div class="metadata-row">
      <span class="label">Company</span>
      <span class="value">{{
        batch?.company?.name || batch?.companyId || 'Not assigned'
      }}</span>
    </div>
    <div class="metadata-row">
      <span class="label">Product</span>
      <span
        class="value chip-list"
        *ngIf="productLabel !== 'Not assigned'; else noProduct"
      >
        <span class="component-chip">{{ productLabel }}</span>
      </span>
      <ng-template #noProduct>
        <span class="value">Not assigned</span>
      </ng-template>
    </div>
    <div class="metadata-row">
      <span class="label">Scope</span>
      <span
        class="value chip-list"
        *ngIf="scopeLabel !== 'Not assigned'; else noScope"
      >
        <span class="component-chip">{{ scopeLabel }}</span>
      </span>
      <ng-template #noScope>
        <span class="value">Not assigned</span>
      </ng-template>
    </div>
    <div class="metadata-row">
      <span class="label">Components</span>
      <span
        class="value chip-list"
        *ngIf="componentNames.length > 0; else noComponents"
      >
        <span
          class="component-chip"
          *ngFor="let componentName of visibleComponentNames"
        >
          {{ componentName }}
        </span>
        <span class="component-chip" *ngIf="hiddenComponentsCount > 0">
          +{{ hiddenComponentsCount }}
        </span>
      </span>
      <ng-template #noComponents>
        <span class="value">Not set</span>
      </ng-template>
    </div>
    <div class="metadata-row">
      <span class="label">Description</span>
      <span class="value description-value" [title]="batchDescription">{{
        batchDescription
      }}</span>
    </div>
    <div class="metadata-row">
      <span class="label">Batch Size</span>
      <span class="value">{{ batch?.licenseBatchSize ?? 0 }}</span>
    </div>
    <div class="metadata-row">
      <span class="label"
        >Assigned {{ isUserTarget ? 'Users' : 'Devices' }}</span
      >
      <span class="value">{{
        isUserTarget ? assignedUsersCount : assignedDevicesCount
      }}</span>
    </div>
    <div class="metadata-row">
      <span class="label">Valid From</span>
      <span class="value">{{ formatDate(batch?.optionalValidAfter) }}</span>
    </div>
    <div class="metadata-row">
      <span class="label">Valid To</span>
      <span class="value">{{ formatDate(batch?.optionalValidBefore) }}</span>
    </div>
  </div>
</article>
